import React from "react";
import styles from "./commoncard.module.scss";
import assets from "../utils/assets";

const ButtonShapped = ({
  text,
  onClick,
  type = "primary",
  disabled = false,
}) => {
  return (
    <div className={`mx-auto d-block ${styles.buttonshaped} ${styles[type]}`} disabled={disabled}>
      <img src={assets.star} alt="" /> <span>{text}</span>
    </div>
  );
};

export default ButtonShapped;
